<template>
  <div class="c-main">
    <h2 class="c-title c-title--page">{{$t('menu.userProfile')}}</h2>
    <form action="#" class="c-main--flex-1 u-margin-bottom-large">
      <div class="o-layout">
        <div class="o-layout__item u-1-of-2-at-small">
          <sceTextField v-model="name" name="name" label="name"
                        v-validate data-vv-rules="required|min:3" :class="{'is-invalid': errors.has('name')}" />
        </div>
        <div class="o-layout__item u-1-of-2-at-small">
          <sceEmailField v-model="email" name="email" label="email"
                        v-validate data-vv-rules="required|email" :class="{'is-invalid': errors.has('email')}" />
        </div>
        <div class="o-layout__item u-1-of-2-at-small">
          <sceTextField v-model="username" name="username" label="username"
                        v-validate data-vv-rules="required|min:3" :class="{'is-invalid': errors.has('username')}" />
        </div>
        <div class="o-layout__item u-1-of-2-at-small o-flex o-flex--align-end">
          <button class="c-button c-button--primary c-button--large u-margin-bottom-small" v-on:click.prevent="changePassword()">
            {{$t('password.change')}}
          </button>
        </div>
      </div>
    </form>
    <footer class="c-footer c-footer--bottom-sticky c-footer--bottom-sticky-fixed-height o-layout">
      <div class="o-layout__item u-1-of-2-at-tiny">
      </div>
      <div class="o-layout__item u-1-of-2-at-tiny u-text-right">
        <button class="c-button c-button--primary c-button--large" v-on:click.prevent="submit()">
          {{$t('save')}}
        </button>
      </div>
    </footer>
    <modal :shown="changePwd" @closed="changePwd = false">
      <change-password @close="changePwd = false" :userId="user.id" />
    </modal>
  </div>
</template>

<script>
  export default {
    name: "userProfile",
    components: {
      'modal': require('client/components/modal.vue').default,
      'changePassword': require('./changePassword.vue').default,
    },
    data: function() {
      return {
        name: null,
        username: null,
        email: null,
        changePwd: false,
      }
    },
    computed: {
      user: function() {
        const userId = this.$route.params.userId
        return this.$store.getters.user(userId)
      },
    },
    created: function() {
      this.name = this.user.name;
      this.username = this.user.username;
      this.email = this.user.email;
    },
    methods: {
      changePassword: function() {
        this.changePwd = true
      },
      submit: function () {
        this.$validator.validateAll().then(() => {
          if (!this.errors.any()) {
            const data = {
              id: this.user.id,
              name: this.name,
              username: this.username,
              email: this.email,
            }

            this.$notify.saveAsync(
                this.$t('menu.userProfile'),
                this.$store.dispatch('user.update', data)
            )
          }
        })
      },
    },
  }
</script>

<style scoped>
</style>
